(function(){
  // mobile menu
  var b=document.querySelector('[data-cz-burger]'),m=document.querySelector('[data-cz-mnav]');
  if(b&&m){b.addEventListener('click',function(){m.classList.toggle('is-on');});}
  // reveal on scroll
  var els=[].slice.call(document.querySelectorAll('.cz-rv'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);});
  } else els.forEach(function(e){e.classList.add('is-in');});
  // cart helpers
  window.czCount=function(n){document.querySelectorAll('[data-cz-count]').forEach(function(c){c.textContent=n;c.hidden=!n;});};
  window.czToast=function(){var t=document.querySelector('[data-cz-toast]');if(!t)return;t.classList.add('is-on');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('is-on');},4200);};
})();
